import { useToaster } from '~/modules/root/context/ToasterContext';

/** The type of action performed on a pin (move, copy, or save). */
type ActionTakenType = 'moved' | 'copied' | 'saved';

interface OnSucessProps {
    actionTaken: ActionTakenType;
    boardName: string;
    pinCount: number;
    urlSegment: string;
}

export const useOnSuccessToast = () => {
    const { toast } = useToaster();
    const onSuccessToast = ({
        actionTaken,
        boardName,
        pinCount,
        urlSegment,
    }: OnSucessProps) => {
        const options = {
            type: 'success' as const,
            clickHereLink: {
                as: 'a',
                href: `/member/design-boards${urlSegment ? `/${urlSegment}` : ''}`,
                children: 'View here',
            },
        };
        if (pinCount === 1) {
            toast(`Pin has been ${actionTaken} to "${boardName}"`, options);
        } else {
            toast(`${pinCount} pins ${actionTaken} to "${boardName}"`, options);
        }
    };

    return { onSuccessToast };
};
